export default __webpack_public_path__ + "995d33a30c3e94375acdc5835e3273df.svg";